var _path, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 112,
    viewBox: "0 0 216 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 108C2 94.0798 4.74178 80.296 10.0688 67.4355C15.3958 54.575 23.2037 42.8896 33.0467 33.0466C42.8897 23.2036 54.5751 15.3957 67.4356 10.0687C80.2961 4.74175 94.0799 1.99999 108 2C121.92 2.00001 135.704 4.74179 148.565 10.0688C161.425 15.3958 173.11 23.2037 182.953 33.0467C192.796 42.8897 200.604 54.5751 205.931 67.4356C211.258 80.2961 214 94.0799 214 108",
    stroke: "#F6C833",
    strokeWidth: 2,
    strokeDasharray: "2 13"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.4,
    x1: -4.37114e-8,
    y1: 107.5,
    x2: 216,
    y2: 107.5,
    stroke: "#F6C833"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 214,
    y1: 112,
    x2: 214,
    y2: 104,
    stroke: "#E5BB46",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 112,
    x2: 2,
    y2: 104,
    stroke: "#E5BB46",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunChart);
export default __webpack_public_path__ + "static/media/sun-chart.8c088e078fe4bff76a161c5ac55b48b2.svg";
export { ForwardRef as ReactComponent };